'use client'

import { PropsWithChildren } from 'react'

import { Link, usePathname } from '@/shared/i18n'
import { Image } from '@/shared/ui'

export const MobileNavigationBar = ({ children }: PropsWithChildren) => {
  const pathname = usePathname()

  const isHostMode = !!pathname?.startsWith('/host')
  const href = isHostMode ? '/host/main' : '/guest/main'

  return (
    <div className="relative flex h-14 w-full shrink-0 items-center justify-center bg-white">
      <h1 className="absolute top-1/2 left-4 -translate-y-1/2 cursor-pointer">
        <Link href={href} className="block w-fit">
          <Image
            src="/image/logo_pc.png"
            alt="33m2"
            width={51}
            height={24}
            external={false}
            priority
            unoptimized
          />
        </Link>
      </h1>

      {children && (
        <h2 className="typo-body1 font-medium text-black">{children}</h2>
      )}
    </div>
  )
}
